import React, { useEffect, useState } from "react";
import {
  getAnalytics,
  jobsExecutions,
  getInvoicesStatus,
  getCommissionStatus,
} from "../../../slices/admin/thunk";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { useNavigate } from "react-router-dom";
import SimulatePanel from "./Components/SimulatePanel";
import Analytics from "./Components/Analytics";
import CronJobs from "./Components/CronJobs";
import Loading from "../../../Components/Loading";
import InvoicesStatus from "./Components/InvoicesStatus";
import ComissionsStatus from "./Components/CommissionsStatus";

import iconAnalitycs from "../../../assets/images/iconsRoles/adminIcon.svg";
import nationalIcon from "../../../assets/images/iconsRoles/nationalIcon.svg";
import gaIcon from "../../../assets/images/iconsRoles/GaIcon.svg";
import brokerIcon from "../../../assets/images/iconsRoles/brokerIcon.svg";
import employerIcon from "../../../assets/images/iconsRoles/employerGroupIcon.svg";
import employeeIcon from "../../../assets/images/iconsRoles/employeesIcon.svg";
import individualIcon from "../../../assets/images/iconsRoles/IndividualsIcon.svg";
import HeadersRole from "../../../Components/Headers/HeadersRole";
import RecentlyAddedEntities from "./Components/RecentlyAddedEntities";

const AdminDashboard = () => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [totalUsers, setTotalUsers] = useState(0);
  const [totalNationals, setTotalNatinonals] = useState(0);
  const [totalGAs, setTotalGAs] = useState(0);
  const [totalBrokers, setTotalBrokers] = useState(0);
  const [totalEmployers, setTotalEmployers] = useState(0);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [totalIndividuals, setTotalIndividuals] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageInvoices, setCurrentPageInvoces] = useState(0);
  const [cronJobsData, setCronJobsData] = useState([]);
  const [pageSize, setPageSize] = useState();
  const [totalItems, setTotalItems] = useState();
  const [totalPages, setTotalPages] = useState();

  const [invoiceStatus, setInvoicesStatus] = useState([]);
  const [loadingInvoices, setLoadingInvoices] = useState(false);
  const [totalItemsStatus, setTotalItemsStatus] = useState();
  const [totalPagesItemStatus, setTotalPagesItemStatus] = useState();
  const [pageSizeItemStatus, setPageSizeItemStatus] = useState();

  const [commissionsStatus, setCommissionsStatus] = useState([]);

  const [loadingJobs, setLoadingJobs] = useState(false);

  const fetchAnalytics = async () => {
    try {
      setLoading(true);
      const response = await dispatch(getAnalytics());
      if (response.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.error
            ? response.error.message || JSON.stringify(response.error)
            : "Unknown error",
        });
        setLoading(false);
      } else {
        setTotalUsers(response.payload.total);
        setTotalNatinonals(response.payload.nationals);
        setTotalGAs(response.payload.gas);
        setTotalBrokers(response.payload.brokers);
        setTotalEmployers(response.payload.employers);
        setTotalEmployees(response.payload.employees);
        setTotalIndividuals(response.payload.individuals);
      }
      setLoading(false);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  const fetchCronJobs = async () => {
    try {
      if (loading) {
        setLoadingJobs(false);
      } else {
        setLoadingJobs(true);
      }

      const response = await dispatch(
        jobsExecutions({
          page: currentPage,
        })
      );
      const res = response.payload;
      if (response.error || !res) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.error
            ? response.error.message || JSON.stringify(response.error)
            : "Unknown error",
        });
        setLoadingJobs(false);
      } else {
        setCronJobsData(res.data);
        setPageSize(res.pageSize);
        setTotalItems(res.total);
        setTotalPages(res.pages);
      }
      setLoadingJobs(false);
    } catch (error) {
      setLoadingJobs(true);
      console.log(error);
      setLoadingJobs(false);
    }
  };

  const fetchInvoicesStatus = async () => {
    try {
      setLoadingInvoices(true);
      const response = await dispatch(
        getInvoicesStatus({ page: currentPageInvoices })
      );

      const res = response.payload;
      if (response.payload) {
        setInvoicesStatus(res);
        setTotalItemsStatus(res.total);
        setPageSizeItemStatus(res.pageSize);
        setTotalPagesItemStatus(res.total);
      } else {
        setInvoicesStatus([]);
      }
      setLoadingInvoices(false);
    } catch (error) {
      setLoadingInvoices(true);
      console.log(error);
      setLoadingInvoices(false);
    }
  };

  const fetchCommissionsStatus = async () => {
    try {
      const response = await dispatch(getCommissionStatus());

      console.log(response);
      setCommissionsStatus(response.payload);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCommissionsStatus();
  }, []);

  useEffect(() => {
    fetchAnalytics();
  }, []);

  useEffect(() => {
    fetchCronJobs();
  }, [currentPage]);

  useEffect(() => {
    fetchInvoicesStatus();
  }, [currentPageInvoices]);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };
  const handleChangePageInvoices = (page) => {
    setCurrentPageInvoces(page);
  };

  const titleBoxs = [
    {
      id: "totalNationals",
      label: "Nationals",
      counter: totalNationals || 0,
      icon: nationalIcon,
      link: "/admin/national",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
    {
      id: "totalGAs",
      label: "GAs",
      counter: totalGAs || 0,
      icon: gaIcon,
      iconClass: "warning",
      link: "/admin/ga",
      decimals: 0,
      prefix: "",
      suffix: "",
    },

    {
      id: "totalBrokers",
      label: "Brokers",
      counter: totalBrokers || 0,
      icon: brokerIcon,
      link: "/admin/brokers",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
    {
      id: "totalEmployers",
      label: "Employers",
      counter: totalEmployers || 0,
      icon: employerIcon,
      link: "/admin/employers",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
    {
      id: "totalEmployees",
      label: "Employees",
      counter: totalEmployees || 0,
      icon: employeeIcon,
      link: "/admin/employees",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
    {
      id: "totalIndividuals",
      label: "Individuals",
      counter: totalIndividuals || 0,
      icon: individualIcon,
      link: "/individuals",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
  ];

  const analyticsLabel = (
    <span className="text-muted">Here are your dasboard details</span>
  );

  return (
    <div className="page-content ">
      <HeadersRole
        role={"Analytics"}
        icon={iconAnalitycs}
        svg={true}
        text={analyticsLabel}
      />
      <Card>
        <CardBody>
          <Row className="d-flex flex-row">
            <Analytics
              titleBoxs={titleBoxs}
              totalUsers={totalUsers}
              loading={loading}
            />
          </Row>
        </CardBody>
      </Card>

      <Row className="mb-4">
        <Col xl={12}>
          <RecentlyAddedEntities
          />
        </Col>
      </Row>

      <Row className="d-flex align-items-start">
        {" "}
        <Col xxl={4} xl={4} lg={12}>
          <Card>
            <CardBody>
              <SimulatePanel />
            </CardBody>
          </Card>
        </Col>
        <Col xxl={8} xl={8} lg={12}>
          <Card>
            <CardBody>
              <CronJobs
                data={cronJobsData}
                loading={loadingJobs}
                paginationProps={{
                  currentPage,
                  totalPages,
                  totalItems: totalItems,
                  pageSize,
                  onChangePage: handleChangePage,
                }}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row className="d-flex align-items-start mb-5 mt-5">
        <Col className="mb-5" xxl={12} xl={12} lg={12}>
          <Card>
            <CardBody>
              <InvoicesStatus
                invoices={invoiceStatus?.data}
                loading={loadingInvoices}
                paginationProps={{
                  currentPage: currentPageInvoices,
                  totalPages: invoiceStatus?.pages,
                  totalItems: totalItemsStatus,
                  pageSize: pageSizeItemStatus,
                  onChangePage: handleChangePageInvoices,
                }}
              />
            </CardBody>
          </Card>
        </Col>

        <Col xxl={12} xl={12} lg={12}>
          <Card>
            <CardBody>
              <ComissionsStatus commissions={commissionsStatus?.data} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AdminDashboard;
